import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Selector from '../../components/forms/Selector';
import TagsEditor from '../../components/forms/TagsEditor';
import language from '../../variables/language';
import '../../css/modals.css';

const TEXT_FIELDS = [
   {name:'firstName', type:'text'},
   {name:'lastName', type:'text'},
   {name:'email', type:'text'},
   {name:'tel', type:'text'},
];
const SELECT_FIELDS = [
   {name:'stage', url:'/api/stages'},
   {name:'source', url:'/api/sources'},
];

const emptyValues = () => ({firstName:'', lastName:'', email:'', tel:'', stage:'', source:''});

export default function ClientCreateModal({ isOpen, onClose, onCreated }) {
   const navigate = useNavigate();
   const [values, setValues] = useState(emptyValues());
   const [tags, setTags] = useState([]);
   const [saving, setSaving] = useState(false);

   if(!isOpen) return '';

   const stopProp = e => e.stopPropagation();

   const handleFieldChange = (name, value) => {
      setValues(prev => ({...prev, [name]: value}));
   }

   const handleClose = () => {
      setValues(emptyValues());
      setTags([]);
      onClose();
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      if(saving) return;
      setSaving(true);
      // backend 401s if a FK/number field is sent as "" - omit unset fields.
      const payload = {};
      Object.keys(values).forEach(key => {
         if(values[key] !== '') {
            payload[key] = values[key];
         }
      });
      axios.post('/api/clients', JSON.stringify(payload), {
         withCredentials: true,
         headers: { 'Content-Type': 'application/json' },
      }).then(response => {
         const created = response.data;
         if(tags.length > 0 && created && created.id) {
            return axios.put('/api/clients/' + created.id + '/tags', JSON.stringify(tags), {
               withCredentials: true,
               headers: { 'Content-Type': 'application/json' },
            });
         }
      }).then(() => {
         setValues(emptyValues());
         setTags([]);
         onCreated();
      }).catch(err => {
         if(err.response && err.response.status === 401){
            navigate('/login');
         }
         console.log(err);
      }).finally(() => {
         setSaving(false);
      });
   }

   return (
      <div className="modal-update" onClick={handleClose} style={{ display: 'flex' }}>
         <div className="modal-window" onClick={stopProp}>
            <h3 className="modal-w-title">{language[language.lang].clientsPage.createClientTitle}</h3>
            <form onSubmit={handleSubmit}>
               <div className='client-create-fields'>
                  {TEXT_FIELDS.map(f => (
                     <div className='flex-from-input-wraper client-create-field' data-label={language[language.lang][f.name]} key={f.name}>
                        <input className='submit-field from-input txt-c' type={f.type}
                           placeholder={language[language.lang][f.name]}
                           value={values[f.name]}
                           onChange={(e) => handleFieldChange(f.name, e.target.value)} />
                     </div>
                  ))}
                  {SELECT_FIELDS.map(f => (
                     <div className='flex-from-input-wraper client-create-field' data-label={language[language.lang][f.name]} key={f.name}>
                        <Selector className='submit-field form-selection txt-c'
                           name={f.name} url={f.url} value={values[f.name]} disabled={false}
                           selectorsHundler={(value) => handleFieldChange(f.name, value)} />
                     </div>
                  ))}
               </div>
               <p className='client-create-section-title'>{language[language.lang].tags}</p>
               <TagsEditor tags={tags} onChange={setTags} />
               <button type='submit' className='form-button txt-c' disabled={saving} style={{marginTop:14}}>
                  {saving ? language[language.lang]['Loading ...'] : language[language.lang].save}
               </button>
            </form>
         </div>
      </div>
   );
}
